import React from 'react';
import { ConfigProvider } from 'antd';
import { createAntdTheme } from './antd-theme';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const antdTheme = createAntdTheme();
  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
};

export default ThemeProvider;
